"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.initialState = void 0;

var _events = require("./constants/events");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var initialState = {
  user: null,
  isLoadingUser: false
};
exports.initialState = initialState;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _events.USER_EXPIRED:
      return _objectSpread({}, state, {
        user: null,
        isLoadingUser: false
      });

    case _events.SILENT_RENEW_ERROR:
      return _objectSpread({}, state, {
        user: null,
        isLoadingUser: false
      });

    case _events.SESSION_TERMINATED:
    case _events.USER_SIGNED_OUT:
      return _objectSpread({}, state, {
        user: null,
        isLoadingUser: false
      });

    case _events.REDIRECT_SUCCESS:
    case _events.USER_FOUND:
      return _objectSpread({}, state, {
        user: action.payload,
        isLoadingUser: false
      });

    case _events.LOADING_USER:
      return _objectSpread({}, state, {
        isLoadingUser: true
      });

    default:
      return state;
  }
}